import * as Sentry from '@sentry/nextjs'
import { useTranslations } from 'next-intl'

interface IProps {
	minAge: number | null
	maxAge: number | null
}

export default function AEmployeeHeroInfoMinimumAge({ minAge, maxAge }: IProps) {
	const t = useTranslations('pages.team_detail.hero.ageRange')

	const getMinimumPatientAge = (minAge: number | null, maxAge: number | null) => {
		try {
			// Age range not defined
			if (!minAge && !maxAge) {
				return t('all')
			}

			// Age range not defined
			if ((minAge === 0 && maxAge === 0) || (minAge === 0 && maxAge === null)) {
				return t('all')
			}

			// Age range not defined
			if ((minAge === 0 && maxAge === 100) || (minAge === 100 && maxAge === null)) {
				return t('all')
			}

			// Age range defined only by min age
			if (minAge !== null && (maxAge === null || maxAge === 0)) {
				return minAge === 1
					? t('minOne', { min: minAge.toString() })
					: t('minMany', { min: minAge.toString() })
			}

			// Age range defined only by max age
			if ((minAge === null || minAge === 0) && maxAge !== null) {
				return t('max', { max: maxAge.toString() })
			}

			// Age range defined by min and max age
			if (minAge !== null && maxAge !== null) {
				return t('range', { min: minAge.toString(), max: maxAge.toString() })
			}

			Sentry.captureException(new Error(`Unhandeled age range: min=${minAge} max=${maxAge}`))
			return null
		} catch (error) {
			Sentry.captureException(error)
			Sentry.captureException(new Error(`Unhandeled age range: min=${minAge} max=${maxAge}`))
			return null
		}
	}

	return (
		<>
			{getMinimumPatientAge(minAge, maxAge) !== null ? (
				<div className='page_content reset_margins nobalance'>
					<p className='font-medium'>
						{t('services', {
							ageRange: getMinimumPatientAge(minAge, maxAge) || ''
						})}
					</p>
				</div>
			) : null}
		</>
	)
}
